<template>
	<section>

        <el-row>
            <el-form :inline="true" :model="filters">
                <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                    <el-form-item >
                        <el-input v-model="filters.conditionSearch" placeholder="Product Name or UPC" clearable @keyup.enter.native="getTrasferUserInfo" style="width: 400px">
                            <el-button slot="append" icon="el-icon-search" @click="getTrasferUserInfo"></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select placeholder="Select Mark Checked" v-model="filters.markChecked" clearable @change="getTrasferUserInfo">
                            <el-option label="Yes" :value="true"></el-option>
                            <el-option label="No" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-form>
        </el-row>

        <el-table stripe :data="dataList" highlight-current-row v-loading="firstLoading" style="width: 100%;">
            <el-table-column prop="id" label="#">
            </el-table-column>
            <el-table-column prop="transferNo" label="Transfer#">
            </el-table-column>
            <el-table-column prop="userName" label="Transferer">
            </el-table-column>
            <el-table-column prop="transferToUserName" label="Acceptor">
            </el-table-column>
            <el-table-column prop="upc" label="UPC">
            </el-table-column>
            <el-table-column prop="productName" label="Product Name">
            </el-table-column>
            <el-table-column prop="qty" label="Qty">
            </el-table-column>
            <el-table-column prop="warehouseAddress" label="Transfer Warehouse Address">
            </el-table-column>
            <el-table-column prop="transferToAddress" label="Acceptor Warehouse Address">
            </el-table-column>
            <el-table-column prop="createDate" label="Transfer Date">
            </el-table-column>
            <el-table-column prop="moved" label="Checked">
                <template slot-scope="scope">
                    <div :style="{ color: scope.row.moved ? 'green' : 'red' }">
                        {{ scope.row.moved ? "Yes" : "No" }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="updateDate" label="Checked Date">
            </el-table-column>
            <el-table-column label="Action">
                <template slot-scope="scope" >
                    <el-button size="small" @click="markChecked(scope.row.id)">
                        Mark Down
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="getTrasferUserInfo" :page-size="pageSize"
                           :total="workingTotal" style="float:right;">
            </el-pagination>
        </el-col>

	</section>
</template>


<script>
    import util from '../../common/js/util'
    import {defaultPageSize} from "../../globalVar";
	import {getTransferUserInfoWithWarehouseByDoctorNo, markChecked} from "../../api/outboundService";

    export default {
        data() {
            return {
                firstLoading: false,
                pageSize:defaultPageSize,
                workingPage:1,
                workingTotal:0,

                filters:{
                    markChecked:"",
                    conditionSearch: "",
                },
                // 转仓数据
                dataList:[],

                loading:false,

                user: sessionStorage.getItem('user'),
            }
        },
		created(){
			this.$on('changeDoctor',(value) => {
				setTimeout(()=>{
					this.getTrasferUserInfo();
				},300);
			});
		},
        methods: {
            // 查询用户转仓信息
            getTrasferUserInfo() {
                let param = {
                    current:this.workingPage,
                    size:this.pageSize,
                    markChecked:this.filters.markChecked,
                    conditionSearch: this.filters.conditionSearch,
                    doctorNo:window.sessionStorage.getItem("currentCompany"),
                }
                this.firstLoading = true;
                getTransferUserInfoWithWarehouseByDoctorNo(param).then((data)=>{
					this.firstLoading = false;
					if(data.status===200){
						this.dataList = data.result.records;
						this.workingTotal = data.result.total;
					}
				})
            },
            markChecked(id){
                this.$confirm('Please confirm if the goods have been properly handled?', 'Warning', {
                    type: 'warning'
                }).then(()=>{
                    let param = {
                        transferId:id
                    };
                    markChecked(param).then((data)=>{
                        if(data.status===200 && data.result){
                            this.getTrasferUserInfo();
                        }else{
                            this.$message.error(data.message)
                        }
                    })
                }).catch(()=>{
                    this.$message.error('Cannot mark the transfer log, please try again later')
                })
            },
        },
        mounted() {
            this.getTrasferUserInfo();
            let user = sessionStorage.getItem('user')
            user = JSON.parse(user);
            this.user = user;
        }
    }

</script>


// WEBPACK FOOTER //
// transferCheck.vue?2bdc5f14